import * as React from "react";

import "./distribution.scss";

import {ForceSticky} from "@Common/react/browser/force-sticky";
import {cs}          from "@Common/react/chain-services";
import {fragments}   from "@Common/react/fragments";
import {keyed}       from "@Common/react/keyed";

import {ScDistributionModules} from "./modules/sc-distribution-modules";

export const Distribution = (
    {
        initEnrollment, program, templateOptions, agentId, branchId,
        next,
    }
) => cs(
    ["modules", (_, next) => ScDistributionModules({initEnrollment, program, templateOptions, agentId, branchId, next})],

    ({modules}) => next({
        enrollmentEditor: modules.enrollmentEditor,
        totalQuantity: modules.totalQuantity,
        estimatedTotal: modules.estimatedTotal,
        getPricePerPiece: modules.getPricePerPiece,
        getSummaryLines: modules.getSummaryLines,
        render: ({showErrors, renderSummary}) => cs(
            ({}, next) => fragments(
                next(),
                modules.renderAfter?.(),
            ),
            ["forceSticky", (_, next) => ForceSticky({next})],
            ({forceSticky}) => (
                <div className="distribution-8ar">
                    <div className="left">
                        {modules.ui.map(({ui, index, hasSpacer}) => cs(
                            keyed(index),
                            ({}, next) => !hasSpacer ? next() : <>
                                <div className="spacer"/>
                                {next()}
                            </>,
                            () => ui({showErrors}),
                        ))}
                    </div>

                    <div className="right">
                        <div className="sticky" ref={forceSticky.domRef}>
                            {renderSummary({className: "summary"})}
                        </div>
                    </div>
                </div>
            ),
        ),
    }),
);
